import { gql } from '@apollo/client'

import { LOCATION_LIST_FRAGMENT } from '../fragments'

const LOCATIONS_QUERY = gql`
  query locations(
    $filters: LocationFiltersInput!
    $pagination: PaginationInput!
  ) {
    locations(filters: $filters, pagination: $pagination) {
      total
      result {
        ...LocationListFragment
      }
    }
  }
  ${LOCATION_LIST_FRAGMENT}
`

export default LOCATIONS_QUERY
